import { render } from "./ArticleComponent.vue?vue&type=template&id=f0b577aa"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import "./ArticleComponent.vue?vue&type=style&index=0&id=f0b577aa&lang=css"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__